import React from 'react';
import { Container, Tabs } from '@mantine/core';
import { GalleryUploader } from '../../../../components/admin/GalleryUploader';

export const ContactUsPage: React.FC = () => {
  return (
    <Container size="xl">
      <Tabs defaultValue="office">
        <Tabs.List>
          <Tabs.Tab value="office">Office Photos</Tabs.Tab>
          <Tabs.Tab value="team">Contact Team</Tabs.Tab>
          <Tabs.Tab value="map">Map Images</Tabs.Tab>
        </Tabs.List>

        <Tabs.Panel value="office" pt="xl">
          <GalleryUploader
            galleryName="CONTACT_US"
            title="Office Photos"
            description="Upload photos of your office, building, and location."
            itemType="IMAGE"
          />
        </Tabs.Panel>

        <Tabs.Panel value="team" pt="xl">
          <GalleryUploader
            galleryName="CONTACT_US"
            title="Contact Team Photos"
            description="Upload photos of your customer service team and key contacts."
            itemType="IMAGE"
          />
        </Tabs.Panel>

        <Tabs.Panel value="map" pt="xl">
          <GalleryUploader
            galleryName="CONTACT_US"
            title="Map Images"
            description="Upload custom map images showing your location."
            itemType="IMAGE"
          />
        </Tabs.Panel>
      </Tabs>
    </Container>
  );
};